import Swiper, {Navigation} from 'swiper';
import Form from '../../components/form';

let slider = {};
const subscribeForm = document.querySelector('.j-form-subscribe');
const newsSlider = document.querySelector('.j-news-slider');


if (subscribeForm) {
    const initSubscribeForm = new Form();

    initSubscribeForm.init({
        target        : subscribeForm,
        successMessage: true
    });
}

if (newsSlider) {
    const options = {
        init             : false,
        modules          : [Navigation],
        loop             : false,
        speed            : 800,
        spaceBetween     : 0,
        slidesPerView    : 'auto',
        slidesOffsetAfter: 0,
        navigation       : {
            nextEl: '.j-news-next',
            prevEl: '.j-news-prev'
        },
        breakpoints: {
            1280: {
                allowTouchMove: false
            }
        }
    };

    slider = new Swiper(newsSlider, options);
    slider.init();
}
